import React from "react";
import { Navigate } from 'react-router-dom';

interface PrivateRouteProps {
    children: React.ReactNode;
    roleRequired?: string[];
    targetInterface?: 'admin' | 'dashboard';
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, roleRequired, targetInterface }) => {
    const userId = localStorage.getItem('userId');
    const userRole = localStorage.getItem('role') || '';

    // Определяем целевой рабочий интерфейс пользователя (с приоритетом на targetInterface из БД)
    const storedInterface = localStorage.getItem('targetInterface');
    const userTargetInterface: 'admin' | 'dashboard' = storedInterface === 'admin' || storedInterface === 'dashboard'
        ? storedInterface
        : (['superadmin', 'admin', 'moder', 'view', 'guide', 'km', 'to', 'full-report'].includes(userRole) ? 'admin' : 'dashboard');

    if (!userId) {
        return <Navigate to="/" replace />;
    }

    // 1. Проверка по бинарному целевому интерфейсу (admin vs dashboard)
    if (targetInterface) {
        if (userTargetInterface !== targetInterface) {
            // Перенаправляем пользователя в его назначенный рабочий интерфейс
            return <Navigate to={userTargetInterface === 'admin' ? '/admin' : '/dashboard'} replace />;
        }
        return <> {children} </>;
    }

    // 2. Обратная совместимость с проверкой по списку ролей (если передано roleRequired)
    if (roleRequired && roleRequired.length > 0) {
        if (!roleRequired.includes(userRole) && userRole !== 'superadmin') {
            return <Navigate to={userTargetInterface === 'admin' ? '/admin' : '/dashboard'} replace />;
        }
    }

    return <> {children} </>;
};

export default PrivateRoute;